/**
 * Style of data-display component cat. consists of
 * - avatarSyles
 * - badgeStyles,
 * - tableStyles,
 * - listStyles,
 * & etc.
 */

export const tableStyles = (theme) => ({
  materialTableStyle__root: {
    '& tbody tr:hover': {
      backgroundColor: 'WhiteSmoke',
      cursor: 'pointer',
    },
  },
  hiddenStyle: {
    display: 'none',
  },
});

export const chipStyles = (theme) => ({
  chipStatusSmallStyle: {
    margin: 0,
    padding: 0,
    borderRadius: 4,
    height: '18px',
    fontSize: '12px',
  },
  chipStatusMediumStyle: {
    margin: 0,
    padding: 0,
    borderRadius: 4,
    height: '25px',
    fontSize: '14px',
  },
  chipStatusLargeStyle: {
    margin: 0,
    padding: 0,
    borderRadius: 4,
    height: '32px',
    fontSize: '14px',
  },
  
  chipLabelSmallStyle: {
    margin: 0,
    padding: 0,
    borderRadius: 15,
    height: '18px',
    fontSize: '12px',
  },
  chipLabelMediumStyle: {
    margin: 0,
    padding: 0,
    borderRadius: 15,
    height: '25px',
    fontSize: '14px',
  },
  chipLabelLargeStyle: {
    margin: 0,
    padding: 0,
    borderRadius: 15,
    height: '32px',
    fontSize: '14px',
  },
 
});
